var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm._f("numFormat")(_vm.result.percentage,"0.00"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }